export const PostType = Object.freeze({
  facebookPost: 'facebookPost',
  instagramPost: 'instagramPost',
  linkedinPost: 'linkedinPost',
  newsletter: 'newsletter',
  facebookAds: 'facebookAds',
  gmbNewsPost: 'gmbNewsPost',
  gmbProductDescription: 'gmbProductDescription',
  customerMailing: 'customerMailing',
  blogPost: 'blogPost',
  websiteText: 'websiteText',
  interview: 'interview',
  download: 'download',
  whatsappStatus: 'whatsappStatus',
})
